import { extendInlineMarkdown } from '@/lib/crm/components/inline-markdown-components';

import { SHIMMER_TEXT_CLASS } from './shimmer';

/**
 * Shared presentation for a reasoning step's one-line title in the chat —
 * the compact steps list's accordion header and the live latest-step line
 * under "Thinking…" render the title identically.
 */

/** A completed (or otherwise not in-progress) step's title. */
export const COMPACT_STEP_LABEL_CLASS = 'text-sm font-medium text-fg-secondary';

/** The in-progress step's title: same size, with the live shimmer. */
export const ACTIVE_STEP_LABEL_CLASS = `text-sm font-medium ${SHIMMER_TEXT_CLASS}`;

/**
 * Inline markdown for the compact button title: the shared block-flattening
 * map, plus links. Autolinked bare URLs (via remarkGfm, always included by
 * MarkdownContent) and explicit markdown links render as a real <a>/nested
 * <button> by default (MarkdownAnchor) — a nested interactive element inside
 * AccordionTrigger's native <button>. Flatten those to plain text too.
 */
export const INLINE_TITLE_MARKDOWN_COMPONENTS = extendInlineMarkdown('a');
